import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';
import * as Models from './model.autogenerated';
import { HttpHeaders } from "@angular/common/http";

export const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

export const httpOptionsMultipart = {};

export abstract class ApiAutogeneratedService {
  constructor(
    public _http: HttpClient,
    public _baseUrl: string,
  ) { }

  protected abstract _momentToString(moment: moment.Moment): string;
  protected abstract _handleRequest<T>(request: T): T;
  protected abstract _handleMultipart<T>(request: T): FormData;
  protected abstract _handleResponse<T>(response: T): T;
  protected abstract _handleError(error: any, obs: any, skipErrorHandling: boolean): Observable<never>;


  public Auth_Token(request: Models.AuthTokenCommand, skipErrorHandling: boolean = false): Observable<Models.AuthenticationToken> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.AuthenticationToken>(`${this._baseUrl}/api/identity/v1/Auth/Token`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Auth_Application(request: Models.AuthApplicationCommand, skipErrorHandling: boolean = false): Observable<Models.AuthenticationToken> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.AuthenticationToken>(`${this._baseUrl}/api/identity/v1/Auth/Application`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Auth_RefreshToken(request: Models.AuthRefreshTokenCommand, skipErrorHandling: boolean = false): Observable<Models.AuthenticationToken> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.AuthenticationToken>(`${this._baseUrl}/api/identity/v1/Auth/RefreshToken`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Auth_TokenHotacDailyRemindCommand(request: Models.AuthTokenHotacDailyRemindCommand, skipErrorHandling: boolean = false): Observable<Models.AuthenticationToken> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.AuthenticationToken>(`${this._baseUrl}/api/identity/v1/Auth/TokenHotacDailyRemindCommand`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Auth_TokenHotacReservationDetailRemind(request: Models.AuthTokenHotacReservationDetailRemindCommand, skipErrorHandling: boolean = false): Observable<Models.AuthenticationToken> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.AuthenticationToken>(`${this._baseUrl}/api/identity/v1/Auth/TokenHotacReservationDetailRemind`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Auth_TokenByIdAuthJwtToken(request: Models.AuthTokenByIdAuthJwtTokenCommand, skipErrorHandling: boolean = false): Observable<Models.AuthenticationToken> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.AuthenticationToken>(`${this._baseUrl}/api/identity/v1/Auth/TokenByIdAuthJwtToken`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Auth_GenerateResetPasswordCode(request: Models.AuthGenerateResetPasswordCodeCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/identity/v1/Auth/GenerateResetPasswordCode`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Auth_ResetPassword(request: Models.AuthResetPasswordCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/identity/v1/Auth/ResetPassword`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Auth_VerifyResetPasswordCode(request: Models.AuthVerifyResetPasswordCodeCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/identity/v1/Auth/VerifyResetPasswordCode`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Auth_ReadRole(idAuthUser?: number, authApplicationCode?: string, skipErrorHandling: boolean = false): Observable<Models.AuthRole> {
    let idAuthUserParam: string = idAuthUser != null && idAuthUser != undefined ? encodeURIComponent('' + idAuthUser) : '';
      let authApplicationCodeParam: string = authApplicationCode != null && authApplicationCode != undefined ? encodeURIComponent('' + authApplicationCode) : '';
      return this._http.post<Models.AuthRole>(`${this._baseUrl}/api/identity/v1/Auth/ReadRole?idAuthUser=${idAuthUserParam}&authApplicationCode=${authApplicationCodeParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public AuthRole_List(authApplicationCode?: string, skipErrorHandling: boolean = false): Observable<Models.AuthRoleListQueryResponse> {
    let authApplicationCodeParam: string = authApplicationCode != null && authApplicationCode != undefined ? encodeURIComponent('' + authApplicationCode) : '';
      return this._http.get<Models.AuthRoleListQueryResponse>(`${this._baseUrl}/api/identity/v1/AuthRole/List?authApplicationCode=${authApplicationCodeParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public BillingInformation_Save(request: Models.BillingInformationSaveCommand, skipErrorHandling: boolean = false): Observable<boolean> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<boolean>(`${this._baseUrl}/api/sales/v1/BillingInformation/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public BillingInformation_Delete(idBillingInformation?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idBillingInformationParam: string = idBillingInformation != null && idBillingInformation != undefined ? encodeURIComponent('' + idBillingInformation) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/BillingInformation/Delete?idBillingInformation=${idBillingInformationParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public ChannelManager_Read(idChannelManager?: number, skipErrorHandling: boolean = false): Observable<Models.ChannelManagerItem> {
    let idChannelManagerParam: string = idChannelManager != null && idChannelManager != undefined ? encodeURIComponent('' + idChannelManager) : '';
      return this._http.get<Models.ChannelManagerItem>(`${this._baseUrl}/api/sales/v1/ChannelManager/Read?idChannelManager=${idChannelManagerParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public ChannelManager_List(skipErrorHandling: boolean = false): Observable<Models.ChannelManagerListResponse> {
    return this._http.get<Models.ChannelManagerListResponse>(`${this._baseUrl}/api/sales/v1/ChannelManager/List`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public ChannelManager_Create(request: Models.ChannelManagerCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/ChannelManager/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public ChannelManager_Update(request: Models.ChannelManagerUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/ChannelManager/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public ChannelManager_Delete(idChannelManager?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idChannelManagerParam: string = idChannelManager != null && idChannelManager != undefined ? encodeURIComponent('' + idChannelManager) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/ChannelManager/Delete?idChannelManager=${idChannelManagerParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public ChannelManager_ListForDropDown(skipErrorHandling: boolean = false): Observable<Models.ChannelManagerListForDropDownResponse> {
    return this._http.get<Models.ChannelManagerListForDropDownResponse>(`${this._baseUrl}/api/sales/v1/ChannelManager/ListForDropDown`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CommercialManagement_Read(idCommercialManagement?: number, skipErrorHandling: boolean = false): Observable<Models.CommercialManagement> {
    let idCommercialManagementParam: string = idCommercialManagement != null && idCommercialManagement != undefined ? encodeURIComponent('' + idCommercialManagement) : '';
      return this._http.get<Models.CommercialManagement>(`${this._baseUrl}/api/sales/v1/CommercialManagement/Read?idCommercialManagement=${idCommercialManagementParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CommercialManagement_List(request?: Models.CommercialManagementListQuery, skipErrorHandling: boolean = false): Observable<Models.CommercialManagementListResponse> {
    let requestParam: string = request != null && request != undefined ? encodeURIComponent('' + request) : '';
      return this._http.get<Models.CommercialManagementListResponse>(`${this._baseUrl}/api/sales/v1/CommercialManagement/List?request=${requestParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CommercialManagement_Create(request: Models.CommercialManagementCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/CommercialManagement/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CommercialManagement_Update(request: Models.CommercialManagementUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/CommercialManagement/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CommercialManagement_Delete(idCommercialManagement?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idCommercialManagementParam: string = idCommercialManagement != null && idCommercialManagement != undefined ? encodeURIComponent('' + idCommercialManagement) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/CommercialManagement/Delete?idCommercialManagement=${idCommercialManagementParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CommercialManagement_ListForDropDown(skipErrorHandling: boolean = false): Observable<Models.CommercialManagementListForDropDownResponse> {
    return this._http.get<Models.CommercialManagementListForDropDownResponse>(`${this._baseUrl}/api/sales/v1/CommercialManagement/ListForDropDown`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Country_List(filter?: string, skipErrorHandling: boolean = false): Observable<Models.CountryListQueryResponse> {
    let filterParam: string = filter != null && filter != undefined ? encodeURIComponent('' + filter) : '';
      return this._http.get<Models.CountryListQueryResponse>(`${this._baseUrl}/api/shared/v1/Country/List?filter=${filterParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerAirlineCompany_Read(idCustomerAirlineCompany: number, skipErrorHandling: boolean = false): Observable<Models.CustomerAirlineCompany> {
    let idCustomerAirlineCompanyParam: string = encodeURIComponent('' + idCustomerAirlineCompany);
      return this._http.get<Models.CustomerAirlineCompany>(`${this._baseUrl}/api/sales/v1/CustomerAirlineCompany/Read?idCustomerAirlineCompany=${idCustomerAirlineCompanyParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerAirlineCompany_List(filter?: string, skipErrorHandling: boolean = false): Observable<Models.CustomerAirlineCompanyListQueryResponse> {
    let filterParam: string = filter != null && filter != undefined ? encodeURIComponent('' + filter) : '';
      return this._http.get<Models.CustomerAirlineCompanyListQueryResponse>(`${this._baseUrl}/api/sales/v1/CustomerAirlineCompany/List?filter=${filterParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerAirlineCompany_Save(request: Models.CustomerAirlineCompanySaveCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/CustomerAirlineCompany/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerAirlineCompany_Delete(idCustomerAirlineCompany: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idCustomerAirlineCompanyParam: string = encodeURIComponent('' + idCustomerAirlineCompany);
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/CustomerAirlineCompany/Delete?idCustomerAirlineCompany=${idCustomerAirlineCompanyParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContract_Read(idCustomerContract?: number, skipErrorHandling: boolean = false): Observable<Models.CustomerContract> {
    let idCustomerContractParam: string = idCustomerContract != null && idCustomerContract != undefined ? encodeURIComponent('' + idCustomerContract) : '';
      return this._http.get<Models.CustomerContract>(`${this._baseUrl}/api/sales/v1/CustomerContract/Read?idCustomerContract=${idCustomerContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContract_List(idCustomerAirlineCompany?: number, skipErrorHandling: boolean = false): Observable<Models.CustomerContractListResponse> {
    let idCustomerAirlineCompanyParam: string = idCustomerAirlineCompany != null && idCustomerAirlineCompany != undefined ? encodeURIComponent('' + idCustomerAirlineCompany) : '';
      return this._http.get<Models.CustomerContractListResponse>(`${this._baseUrl}/api/sales/v1/CustomerContract/List?idCustomerAirlineCompany=${idCustomerAirlineCompanyParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContract_Save(request: Models.CustomerContractSaveCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/CustomerContract/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContract_Delete(idCustomerContract?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idCustomerContractParam: string = idCustomerContract != null && idCustomerContract != undefined ? encodeURIComponent('' + idCustomerContract) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/CustomerContract/Delete?idCustomerContract=${idCustomerContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContract_Clone(request: Models.CustomerContractCloneCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/CustomerContract/Clone`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractAttachment_List(idCustomerContract?: number, skipErrorHandling: boolean = false): Observable<Models.CustomerContractAttachmentListQueryResponse> {
    let idCustomerContractParam: string = idCustomerContract != null && idCustomerContract != undefined ? encodeURIComponent('' + idCustomerContract) : '';
      return this._http.get<Models.CustomerContractAttachmentListQueryResponse>(`${this._baseUrl}/api/sales/v1/CustomerContractAttachment/List?idCustomerContract=${idCustomerContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractAttachment_Create(request: Models.CustomerContractAttachmentCreate, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleMultipart(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/CustomerContractAttachment/Create`, wrappedRequest, httpOptionsMultipart)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractAttachment_Delete(request: Models.CustomerContractAttachmentDeleteCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/CustomerContractAttachment/Delete`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractHotelRate_ReadFlatRate(idCustomerContractHotelRate?: number, skipErrorHandling: boolean = false): Observable<Models.CustomerContractHotelRateFlat> {
    let idCustomerContractHotelRateParam: string = idCustomerContractHotelRate != null && idCustomerContractHotelRate != undefined ? encodeURIComponent('' + idCustomerContractHotelRate) : '';
      return this._http.get<Models.CustomerContractHotelRateFlat>(`${this._baseUrl}/api/sales/v1/CustomerContractHotelRate/ReadFlatRate?idCustomerContractHotelRate=${idCustomerContractHotelRateParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractHotelRate_ReadPercentageRate(idCustomerContract?: number, skipErrorHandling: boolean = false): Observable<Models.CustomerContractHotelRatePercentage> {
    let idCustomerContractParam: string = idCustomerContract != null && idCustomerContract != undefined ? encodeURIComponent('' + idCustomerContract) : '';
      return this._http.get<Models.CustomerContractHotelRatePercentage>(`${this._baseUrl}/api/sales/v1/CustomerContractHotelRate/ReadPercentageRate?idCustomerContract=${idCustomerContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractHotelRate_SaveFlatRates(request: Models.CustomerContractHotelSaveFlatRateCommand, skipErrorHandling: boolean = false): Observable<boolean> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<boolean>(`${this._baseUrl}/api/sales/v1/CustomerContractHotelRate/SaveFlatRates`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractHotelRate_SavePercentageRates(request: Models.CustomerContractHotelSavePercentageRateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/CustomerContractHotelRate/SavePercentageRates`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractHotelRate_Clone(request: Models.CustomerContractHotelRateCloneCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/CustomerContractHotelRate/Clone`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractHotelRate_Delete(idCustomerContractHotelRate?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idCustomerContractHotelRateParam: string = idCustomerContractHotelRate != null && idCustomerContractHotelRate != undefined ? encodeURIComponent('' + idCustomerContractHotelRate) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/CustomerContractHotelRate/Delete?idCustomerContractHotelRate=${idCustomerContractHotelRateParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractHotelRate_List(idCustomerContract?: number, skipErrorHandling: boolean = false): Observable<Models.CustomerContractHotelRateListQueryResponse> {
    let idCustomerContractParam: string = idCustomerContract != null && idCustomerContract != undefined ? encodeURIComponent('' + idCustomerContract) : '';
      return this._http.get<Models.CustomerContractHotelRateListQueryResponse>(`${this._baseUrl}/api/sales/v1/CustomerContractHotelRate/List?idCustomerContract=${idCustomerContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractHotelRate_IdTransportHubList(idCustomerContract?: number, skipErrorHandling: boolean = false): Observable<Models.CustomerContractHotelRateIdTransportHubListQueryResponse> {
    let idCustomerContractParam: string = idCustomerContract != null && idCustomerContract != undefined ? encodeURIComponent('' + idCustomerContract) : '';
      return this._http.get<Models.CustomerContractHotelRateIdTransportHubListQueryResponse>(`${this._baseUrl}/api/sales/v1/CustomerContractHotelRate/IdTransportHubList?idCustomerContract=${idCustomerContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractTransportRate_Read(idSupplierTransportContractPlanRate?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransportContractPlanRate> {
    let idSupplierTransportContractPlanRateParam: string = idSupplierTransportContractPlanRate != null && idSupplierTransportContractPlanRate != undefined ? encodeURIComponent('' + idSupplierTransportContractPlanRate) : '';
      return this._http.get<Models.SupplierTransportContractPlanRate>(`${this._baseUrl}/api/sales/v1/CustomerContractTransportRate/Read?idSupplierTransportContractPlanRate=${idSupplierTransportContractPlanRateParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractTransportRate_List(idCustomerContract?: number, skipErrorHandling: boolean = false): Observable<Models.CustomerContractTransportRateListQueryResponse> {
    let idCustomerContractParam: string = idCustomerContract != null && idCustomerContract != undefined ? encodeURIComponent('' + idCustomerContract) : '';
      return this._http.get<Models.CustomerContractTransportRateListQueryResponse>(`${this._baseUrl}/api/sales/v1/CustomerContractTransportRate/List?idCustomerContract=${idCustomerContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public CustomerContractTransportRate_Save(request: Models.CustomerContractTransportRateSaveCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/CustomerContractTransportRate/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Enum_List(skipErrorHandling: boolean = false): Observable<Models.SalesEnumInitializationQueryResponse> {
    return this._http.get<Models.SalesEnumInitializationQueryResponse>(`${this._baseUrl}/api/sales/v1/Enum/List`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Hotac_TestSend(request: Models.HotacTestSendCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/Hotac/TestSend`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Hotel_Read(idHotel?: number, skipErrorHandling: boolean = false): Observable<Models.Hotel> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      return this._http.get<Models.Hotel>(`${this._baseUrl}/api/sales/v1/Hotel/Read?idHotel=${idHotelParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Hotel_List(pageNumber?: number, pageSize?: number, filter?: string, transportHubsContains?: string, nameContains?: string, idCommercialManagement?: number, rooms?: number, idDealProcessingState?: number, idHotelContractType?: number, idHotelContractState?: number, ownerNameContains?: string, representativeEmailContains?: string, updatedAtDate?: moment.Moment, roomAvailabilityCommunicationMode?: string, sortField?: string, sortOrder?: number, skipErrorHandling: boolean = false): Observable<Models.HotelListResponse> {
    let pageNumberParam: string = pageNumber != null && pageNumber != undefined ? encodeURIComponent('' + pageNumber) : '';
      let pageSizeParam: string = pageSize != null && pageSize != undefined ? encodeURIComponent('' + pageSize) : '';
      let filterParam: string = filter != null && filter != undefined ? encodeURIComponent('' + filter) : '';
      let transportHubsContainsParam: string = transportHubsContains != null && transportHubsContains != undefined ? encodeURIComponent('' + transportHubsContains) : '';
      let nameContainsParam: string = nameContains != null && nameContains != undefined ? encodeURIComponent('' + nameContains) : '';
      let idCommercialManagementParam: string = idCommercialManagement != null && idCommercialManagement != undefined ? encodeURIComponent('' + idCommercialManagement) : '';
      let roomsParam: string = rooms != null && rooms != undefined ? encodeURIComponent('' + rooms) : '';
      let idDealProcessingStateParam: string = idDealProcessingState != null && idDealProcessingState != undefined ? encodeURIComponent('' + idDealProcessingState) : '';
      let idHotelContractTypeParam: string = idHotelContractType != null && idHotelContractType != undefined ? encodeURIComponent('' + idHotelContractType) : '';
      let idHotelContractStateParam: string = idHotelContractState != null && idHotelContractState != undefined ? encodeURIComponent('' + idHotelContractState) : '';
      let ownerNameContainsParam: string = ownerNameContains != null && ownerNameContains != undefined ? encodeURIComponent('' + ownerNameContains) : '';
      let representativeEmailContainsParam: string = representativeEmailContains != null && representativeEmailContains != undefined ? encodeURIComponent('' + representativeEmailContains) : '';
      let updatedAtDateParam: string = updatedAtDate != null && updatedAtDate != undefined && updatedAtDate.isValid() ? encodeURIComponent(this._momentToString(updatedAtDate)) : '';
      let roomAvailabilityCommunicationModeParam: string = roomAvailabilityCommunicationMode != null && roomAvailabilityCommunicationMode != undefined ? encodeURIComponent('' + roomAvailabilityCommunicationMode) : '';
      let sortFieldParam: string = sortField != null && sortField != undefined ? encodeURIComponent('' + sortField) : '';
      let sortOrderParam: string = sortOrder != null && sortOrder != undefined ? encodeURIComponent('' + sortOrder) : '';
      return this._http.get<Models.HotelListResponse>(`${this._baseUrl}/api/sales/v1/Hotel/List?pageNumber=${pageNumberParam}&pageSize=${pageSizeParam}&filter=${filterParam}&transportHubsContains=${transportHubsContainsParam}&nameContains=${nameContainsParam}&idCommercialManagement=${idCommercialManagementParam}&rooms=${roomsParam}&idDealProcessingState=${idDealProcessingStateParam}&idHotelContractType=${idHotelContractTypeParam}&idHotelContractState=${idHotelContractStateParam}&ownerNameContains=${ownerNameContainsParam}&representativeEmailContains=${representativeEmailContainsParam}&updatedAtDate=${updatedAtDateParam}&roomAvailabilityCommunicationMode=${roomAvailabilityCommunicationModeParam}&sortField=${sortFieldParam}&sortOrder=${sortOrderParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Hotel_Create(request: Models.HotelCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/Hotel/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Hotel_Update(request: Models.HotelUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/Hotel/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Hotel_Delete(idHotel?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/Hotel/Delete?idHotel=${idHotelParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Hotel_ExcelExport(skipErrorHandling: boolean = false): Observable<Models.HotelExcelExportResponse> {
    return this._http.get<Models.HotelExcelExportResponse>(`${this._baseUrl}/api/sales/v1/Hotel/ExcelExport`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Hotel_RoomAvailabilityCommunicationMode(idHotel?: number, skipErrorHandling: boolean = false): Observable<Models.HotelRoomAvailabilityCommunicationMode> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      return this._http.get<Models.HotelRoomAvailabilityCommunicationMode>(`${this._baseUrl}/api/sales/v1/Hotel/RoomAvailabilityCommunicationMode?idHotel=${idHotelParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelAiCallConfiguration_Read(idHotel?: number, skipErrorHandling: boolean = false): Observable<Models.HotelAiCallConfigurationItem> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      return this._http.get<Models.HotelAiCallConfigurationItem>(`${this._baseUrl}/api/sales/v1/HotelAiCallConfiguration/Read?idHotel=${idHotelParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelAiCallConfiguration_Save(request: Models.HotelAiCallConfigurationSaveCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/HotelAiCallConfiguration/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelBookingContact_Read(idHotel?: number, skipErrorHandling: boolean = false): Observable<Models.HotelBookingContact> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      return this._http.get<Models.HotelBookingContact>(`${this._baseUrl}/api/sales/v1/HotelBookingContact/Read?idHotel=${idHotelParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelBookingContact_Save(request: Models.HotelBookingContactSaveCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelBookingContact/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelChain_Read(idHotelChain?: number, skipErrorHandling: boolean = false): Observable<Models.HotelChain> {
    let idHotelChainParam: string = idHotelChain != null && idHotelChain != undefined ? encodeURIComponent('' + idHotelChain) : '';
      return this._http.get<Models.HotelChain>(`${this._baseUrl}/api/sales/v1/HotelChain/Read?idHotelChain=${idHotelChainParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelChain_List(skipErrorHandling: boolean = false): Observable<Models.HotelChainListResponse> {
    return this._http.get<Models.HotelChainListResponse>(`${this._baseUrl}/api/sales/v1/HotelChain/List`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelChain_Create(request: Models.HotelChainCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/HotelChain/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelChain_Update(request: Models.HotelChainUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelChain/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelChain_Delete(idHotelChain?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idHotelChainParam: string = idHotelChain != null && idHotelChain != undefined ? encodeURIComponent('' + idHotelChain) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelChain/Delete?idHotelChain=${idHotelChainParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelChain_ListForDropDown(skipErrorHandling: boolean = false): Observable<Models.HotelChainListForDropDownResponse> {
    return this._http.get<Models.HotelChainListForDropDownResponse>(`${this._baseUrl}/api/sales/v1/HotelChain/ListForDropDown`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContract_Read(idContract?: number, skipErrorHandling: boolean = false): Observable<Models.HotelContractItem> {
    let idContractParam: string = idContract != null && idContract != undefined ? encodeURIComponent('' + idContract) : '';
      return this._http.get<Models.HotelContractItem>(`${this._baseUrl}/api/sales/v1/HotelContract/Read?idContract=${idContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContract_List(idHotel?: number, skipErrorHandling: boolean = false): Observable<Models.HotelContractListResponse> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      return this._http.get<Models.HotelContractListResponse>(`${this._baseUrl}/api/sales/v1/HotelContract/List?idHotel=${idHotelParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContract_Create(request: Models.HotelContractCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/HotelContract/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContract_Update(request: Models.HotelContractUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelContract/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContract_Delete(idHotelContract?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idHotelContractParam: string = idHotelContract != null && idHotelContract != undefined ? encodeURIComponent('' + idHotelContract) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelContract/Delete?idHotelContract=${idHotelContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContract_Clone(request: Models.HotelContractCloneCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelContract/Clone`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContractAttachment_Read(idHotelContractAttachment?: number, skipErrorHandling: boolean = false): Observable<Models.HotelContractAttachment> {
    let idHotelContractAttachmentParam: string = idHotelContractAttachment != null && idHotelContractAttachment != undefined ? encodeURIComponent('' + idHotelContractAttachment) : '';
      return this._http.get<Models.HotelContractAttachment>(`${this._baseUrl}/api/sales/v1/HotelContractAttachment/Read?idHotelContractAttachment=${idHotelContractAttachmentParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContractAttachment_List(idContract?: number, skipErrorHandling: boolean = false): Observable<Models.ContractAttachmentListQueryResponse> {
    let idContractParam: string = idContract != null && idContract != undefined ? encodeURIComponent('' + idContract) : '';
      return this._http.get<Models.ContractAttachmentListQueryResponse>(`${this._baseUrl}/api/sales/v1/HotelContractAttachment/List?idContract=${idContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContractAttachment_Create(request: Models.HotelContractAttachmentCreate, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleMultipart(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/HotelContractAttachment/Create`, wrappedRequest, httpOptionsMultipart)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContractAttachment_Delete(request: Models.HotelContractAttachmentDeleteCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelContractAttachment/Delete`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContractPlanRate_Read(idContract?: number, skipErrorHandling: boolean = false): Observable<Models.HotelContractPlanRateReadQueryResponse> {
    let idContractParam: string = idContract != null && idContract != undefined ? encodeURIComponent('' + idContract) : '';
      return this._http.get<Models.HotelContractPlanRateReadQueryResponse>(`${this._baseUrl}/api/sales/v1/HotelContractPlanRate/Read?idContract=${idContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContractPlanRate_Save(request: Models.HotelContractPlanRateSaveCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/HotelContractPlanRate/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContractPlanRate_Delete(idHotelContractPlanRate?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idHotelContractPlanRateParam: string = idHotelContractPlanRate != null && idHotelContractPlanRate != undefined ? encodeURIComponent('' + idHotelContractPlanRate) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelContractPlanRate/Delete?idHotelContractPlanRate=${idHotelContractPlanRateParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContractService_List(idHotelContract?: number, skipErrorHandling: boolean = false): Observable<Models.ContractServiceListResponse> {
    let idHotelContractParam: string = idHotelContract != null && idHotelContract != undefined ? encodeURIComponent('' + idHotelContract) : '';
      return this._http.get<Models.ContractServiceListResponse>(`${this._baseUrl}/api/sales/v1/HotelContractService/List?idHotelContract=${idHotelContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelContractService_Save(request: Models.HotelContractServiceSaveCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelContractService/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelIropContact_List(idHotel?: number, skipErrorHandling: boolean = false): Observable<Models.HotelIropContactListResponse> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      return this._http.get<Models.HotelIropContactListResponse>(`${this._baseUrl}/api/sales/v1/HotelIropContact/List?idHotel=${idHotelParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public HotelIropContact_Save(request: Models.HotelIropContactSaveCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/HotelIropContact/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public IanaName_ListForDropDown(skipErrorHandling: boolean = false): Observable<Models.IanaNameListForDropDownResponse> {
    return this._http.get<Models.IanaNameListForDropDownResponse>(`${this._baseUrl}/api/shared/v1/IanaName/ListForDropDown`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public LanguageCulture_List(skipErrorHandling: boolean = false): Observable<Models.LanguageCultureListQueryResponse> {
    return this._http.get<Models.LanguageCultureListQueryResponse>(`${this._baseUrl}/api/shared/v1/LanguageCulture/List`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Ownership_Read(idHotel?: number, idCommercialManagement?: number, idCustomer?: number, skipErrorHandling: boolean = false): Observable<Models.OwnershipItem> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      let idCommercialManagementParam: string = idCommercialManagement != null && idCommercialManagement != undefined ? encodeURIComponent('' + idCommercialManagement) : '';
      let idCustomerParam: string = idCustomer != null && idCustomer != undefined ? encodeURIComponent('' + idCustomer) : '';
      return this._http.get<Models.OwnershipItem>(`${this._baseUrl}/api/sales/v1/Ownership/Read?idHotel=${idHotelParam}&idCommercialManagement=${idCommercialManagementParam}&idCustomer=${idCustomerParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Ownership_Create(request: Models.OwnershipCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/Ownership/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Ownership_Update(request: Models.OwnershipUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/Ownership/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Representative_Read(idRepresentative?: number, skipErrorHandling: boolean = false): Observable<Models.Representative> {
    let idRepresentativeParam: string = idRepresentative != null && idRepresentative != undefined ? encodeURIComponent('' + idRepresentative) : '';
      return this._http.get<Models.Representative>(`${this._baseUrl}/api/sales/v1/Representative/Read?idRepresentative=${idRepresentativeParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Representative_List(idHotel?: number, idCommercialManagement?: number, idCustomer?: number, skipErrorHandling: boolean = false): Observable<Models.RepresentativeListResponse> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      let idCommercialManagementParam: string = idCommercialManagement != null && idCommercialManagement != undefined ? encodeURIComponent('' + idCommercialManagement) : '';
      let idCustomerParam: string = idCustomer != null && idCustomer != undefined ? encodeURIComponent('' + idCustomer) : '';
      return this._http.get<Models.RepresentativeListResponse>(`${this._baseUrl}/api/sales/v1/Representative/List?idHotel=${idHotelParam}&idCommercialManagement=${idCommercialManagementParam}&idCustomer=${idCustomerParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Representative_Create(request: Models.RepresentativeCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/Representative/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Representative_Update(request: Models.RepresentativeUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/Representative/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public Representative_Delete(idRepresentative?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idRepresentativeParam: string = idRepresentative != null && idRepresentative != undefined ? encodeURIComponent('' + idRepresentative) : '';
      return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/Representative/Delete?idRepresentative=${idRepresentativeParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SalesCommunicationActivity_Read(idSalesCommunicationActivity?: number, skipErrorHandling: boolean = false): Observable<Models.SalesCommunicationActivityItem> {
    let idSalesCommunicationActivityParam: string = idSalesCommunicationActivity != null && idSalesCommunicationActivity != undefined ? encodeURIComponent('' + idSalesCommunicationActivity) : '';
      return this._http.get<Models.SalesCommunicationActivityItem>(`${this._baseUrl}/api/sales/v1/SalesCommunicationActivity/Read?idSalesCommunicationActivity=${idSalesCommunicationActivityParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SalesCommunicationActivity_List(idHotel?: number, idCommercialManagement?: number, skipErrorHandling: boolean = false): Observable<Models.SalesCommunicationActivityListResponse> {
    let idHotelParam: string = idHotel != null && idHotel != undefined ? encodeURIComponent('' + idHotel) : '';
      let idCommercialManagementParam: string = idCommercialManagement != null && idCommercialManagement != undefined ? encodeURIComponent('' + idCommercialManagement) : '';
      return this._http.get<Models.SalesCommunicationActivityListResponse>(`${this._baseUrl}/api/sales/v1/SalesCommunicationActivity/List?idHotel=${idHotelParam}&idCommercialManagement=${idCommercialManagementParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SalesCommunicationActivity_Create(request: Models.SalesCommunicationActivityCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SalesCommunicationActivity/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SalesCommunicationActivity_Update(request: Models.SalesCommunicationActivityUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/SalesCommunicationActivity/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SalesCommunicationActivity_Delete(idSalesCommunicationActivity?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idSalesCommunicationActivityParam: string = idSalesCommunicationActivity != null && idSalesCommunicationActivity != undefined ? encodeURIComponent('' + idSalesCommunicationActivity) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/SalesCommunicationActivity/Delete?idSalesCommunicationActivity=${idSalesCommunicationActivityParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SalesCommunicationActivityAttachment_Read(idSalesCommunicationActivityAttachment?: number, skipErrorHandling: boolean = false): Observable<Models.SalesCommunicationActivityAttachment> {
    let idSalesCommunicationActivityAttachmentParam: string = idSalesCommunicationActivityAttachment != null && idSalesCommunicationActivityAttachment != undefined ? encodeURIComponent('' + idSalesCommunicationActivityAttachment) : '';
      return this._http.get<Models.SalesCommunicationActivityAttachment>(`${this._baseUrl}/api/sales/v1/SalesCommunicationActivityAttachment/Read?idSalesCommunicationActivityAttachment=${idSalesCommunicationActivityAttachmentParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SalesCommunicationActivityAttachment_List(idSalesCommunicationActivity?: number, skipErrorHandling: boolean = false): Observable<Models.SalesCommunicationActivityAttachmentListQueryResponse> {
    let idSalesCommunicationActivityParam: string = idSalesCommunicationActivity != null && idSalesCommunicationActivity != undefined ? encodeURIComponent('' + idSalesCommunicationActivity) : '';
      return this._http.get<Models.SalesCommunicationActivityAttachmentListQueryResponse>(`${this._baseUrl}/api/sales/v1/SalesCommunicationActivityAttachment/List?idSalesCommunicationActivity=${idSalesCommunicationActivityParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SalesCommunicationActivityAttachment_Create(request: Models.SalesCommunicationActivityAttachmentCreate, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleMultipart(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SalesCommunicationActivityAttachment/Create`, wrappedRequest, httpOptionsMultipart)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SalesCommunicationActivityAttachment_Delete(request: Models.SalesCommunicationActivityAttachmentDeleteCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/SalesCommunicationActivityAttachment/Delete`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierContact_ListByIdSupplier(idSupplier?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierContactListByIdSupplierQueryResponse> {
    let idSupplierParam: string = idSupplier != null && idSupplier != undefined ? encodeURIComponent('' + idSupplier) : '';
      return this._http.get<Models.SupplierContactListByIdSupplierQueryResponse>(`${this._baseUrl}/api/sales/v1/SupplierContact/ListByIdSupplier?idSupplier=${idSupplierParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierContact_Read(idSupplierContact?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierContact> {
    let idSupplierContactParam: string = idSupplierContact != null && idSupplierContact != undefined ? encodeURIComponent('' + idSupplierContact) : '';
      return this._http.get<Models.SupplierContact>(`${this._baseUrl}/api/sales/v1/SupplierContact/Read?idSupplierContact=${idSupplierContactParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierContact_Create(request: Models.SupplierContactCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SupplierContact/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierContact_Update(request: Models.SupplierContactUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/SupplierContact/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierContact_Delete(idSupplierContact?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idSupplierContactParam: string = idSupplierContact != null && idSupplierContact != undefined ? encodeURIComponent('' + idSupplierContact) : '';
      return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/SupplierContact/Delete?idSupplierContact=${idSupplierContactParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransport_List(skipErrorHandling: boolean = false): Observable<Models.SupplierTransportListQueryResponse> {
    return this._http.get<Models.SupplierTransportListQueryResponse>(`${this._baseUrl}/api/sales/v1/SupplierTransport/List`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransport_Read(idSupplierTransport?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransport> {
    let idSupplierTransportParam: string = idSupplierTransport != null && idSupplierTransport != undefined ? encodeURIComponent('' + idSupplierTransport) : '';
      return this._http.get<Models.SupplierTransport>(`${this._baseUrl}/api/sales/v1/SupplierTransport/Read?idSupplierTransport=${idSupplierTransportParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransport_Save(request: Models.SupplierTransportSaveCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SupplierTransport/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransport_Delete(idSupplierTransport?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idSupplierTransportParam: string = idSupplierTransport != null && idSupplierTransport != undefined ? encodeURIComponent('' + idSupplierTransport) : '';
      return this._http.post<Models.Result>(`${this._baseUrl}/api/sales/v1/SupplierTransport/Delete?idSupplierTransport=${idSupplierTransportParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContract_List(idSupplierTransport?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransportContractListQueryResponse> {
    let idSupplierTransportParam: string = idSupplierTransport != null && idSupplierTransport != undefined ? encodeURIComponent('' + idSupplierTransport) : '';
      return this._http.get<Models.SupplierTransportContractListQueryResponse>(`${this._baseUrl}/api/sales/v1/SupplierTransportContract/List?idSupplierTransport=${idSupplierTransportParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContract_Read(idSupplierTransportContract?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransportContract> {
    let idSupplierTransportContractParam: string = idSupplierTransportContract != null && idSupplierTransportContract != undefined ? encodeURIComponent('' + idSupplierTransportContract) : '';
      return this._http.get<Models.SupplierTransportContract>(`${this._baseUrl}/api/sales/v1/SupplierTransportContract/Read?idSupplierTransportContract=${idSupplierTransportContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContract_Save(request: Models.SupplierTransportContractSaveCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SupplierTransportContract/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContract_Delete(idSupplierTransportContract: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idSupplierTransportContractParam: string = encodeURIComponent('' + idSupplierTransportContract);
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/SupplierTransportContract/Delete?idSupplierTransportContract=${idSupplierTransportContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContract_Clone(request: Models.SupplierTransportContractCloneCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SupplierTransportContract/Clone`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractPlanRate_List(idSupplierTransportContract?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransportContractPlanRateListQueryResponse> {
    let idSupplierTransportContractParam: string = idSupplierTransportContract != null && idSupplierTransportContract != undefined ? encodeURIComponent('' + idSupplierTransportContract) : '';
      return this._http.get<Models.SupplierTransportContractPlanRateListQueryResponse>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractPlanRate/List?idSupplierTransportContract=${idSupplierTransportContractParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractPlanRate_Read(idSupplierTransportContractPlanRate?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransportContractPlanRate> {
    let idSupplierTransportContractPlanRateParam: string = idSupplierTransportContractPlanRate != null && idSupplierTransportContractPlanRate != undefined ? encodeURIComponent('' + idSupplierTransportContractPlanRate) : '';
      return this._http.get<Models.SupplierTransportContractPlanRate>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractPlanRate/Read?idSupplierTransportContractPlanRate=${idSupplierTransportContractPlanRateParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractPlanRate_Save(request: Models.SupplierTransportContractPlanRateSaveCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractPlanRate/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractPlanRate_Clone(request: Models.SupplierTransportContractPlanRateCloneCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractPlanRate/Clone`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractPlanRate_Delete(idSupplierTransportContractPlanRate?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idSupplierTransportContractPlanRateParam: string = idSupplierTransportContractPlanRate != null && idSupplierTransportContractPlanRate != undefined ? encodeURIComponent('' + idSupplierTransportContractPlanRate) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractPlanRate/Delete?idSupplierTransportContractPlanRate=${idSupplierTransportContractPlanRateParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractRouteCost_Read(idSupplierTransportContractRouteCost?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransportContractRouteCost> {
    let idSupplierTransportContractRouteCostParam: string = idSupplierTransportContractRouteCost != null && idSupplierTransportContractRouteCost != undefined ? encodeURIComponent('' + idSupplierTransportContractRouteCost) : '';
      return this._http.get<Models.SupplierTransportContractRouteCost>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractRouteCost/Read?idSupplierTransportContractRouteCost=${idSupplierTransportContractRouteCostParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractRouteCost_List(idSupplierTransportContractPlanRate?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransportContractRouteCostListQueryResponse> {
    let idSupplierTransportContractPlanRateParam: string = idSupplierTransportContractPlanRate != null && idSupplierTransportContractPlanRate != undefined ? encodeURIComponent('' + idSupplierTransportContractPlanRate) : '';
      return this._http.get<Models.SupplierTransportContractRouteCostListQueryResponse>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractRouteCost/List?idSupplierTransportContractPlanRate=${idSupplierTransportContractPlanRateParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractRouteCost_Save(request: Models.SupplierTransportContractRouteCostSaveCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractRouteCost/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractRouteCost_Delete(idSupplierTransportContractRouteCost?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idSupplierTransportContractRouteCostParam: string = idSupplierTransportContractRouteCost != null && idSupplierTransportContractRouteCost != undefined ? encodeURIComponent('' + idSupplierTransportContractRouteCost) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractRouteCost/Delete?idSupplierTransportContractRouteCost=${idSupplierTransportContractRouteCostParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractSupplement_Read(idSupplierTransportContractPlanRate?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransportContractSupplement> {
    let idSupplierTransportContractPlanRateParam: string = idSupplierTransportContractPlanRate != null && idSupplierTransportContractPlanRate != undefined ? encodeURIComponent('' + idSupplierTransportContractPlanRate) : '';
      return this._http.get<Models.SupplierTransportContractSupplement>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractSupplement/Read?idSupplierTransportContractPlanRate=${idSupplierTransportContractPlanRateParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractSupplement_List(idSupplierTransportContractPlanRate?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierTransportContractSupplementListQueryResponse> {
    let idSupplierTransportContractPlanRateParam: string = idSupplierTransportContractPlanRate != null && idSupplierTransportContractPlanRate != undefined ? encodeURIComponent('' + idSupplierTransportContractPlanRate) : '';
      return this._http.get<Models.SupplierTransportContractSupplementListQueryResponse>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractSupplement/List?idSupplierTransportContractPlanRate=${idSupplierTransportContractPlanRateParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractSupplement_Save(request: Models.SupplierTransportContractSupplementSaveCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractSupplement/Save`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public SupplierTransportContractSupplement_Delete(idSupplierTransportContractSupplement?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idSupplierTransportContractSupplementParam: string = idSupplierTransportContractSupplement != null && idSupplierTransportContractSupplement != undefined ? encodeURIComponent('' + idSupplierTransportContractSupplement) : '';
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/sales/v1/SupplierTransportContractSupplement/Delete?idSupplierTransportContractSupplement=${idSupplierTransportContractSupplementParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TimeZone_Read(idTimeZone?: number, skipErrorHandling: boolean = false): Observable<Models.TimeZoneItem> {
    let idTimeZoneParam: string = idTimeZone != null && idTimeZone != undefined ? encodeURIComponent('' + idTimeZone) : '';
      return this._http.get<Models.TimeZoneItem>(`${this._baseUrl}/api/shared/v1/TimeZone/Read?idTimeZone=${idTimeZoneParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TimeZone_List(request?: Models.TimeZoneListQuery, skipErrorHandling: boolean = false): Observable<Models.TimeZoneListQueryResponse> {
    let requestParam: string = request != null && request != undefined ? encodeURIComponent('' + request) : '';
      return this._http.get<Models.TimeZoneListQueryResponse>(`${this._baseUrl}/api/shared/v1/TimeZone/List?request=${requestParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TimeZone_ListForDropDown(skipErrorHandling: boolean = false): Observable<Models.TimeZoneListForDropDownResponse> {
    return this._http.get<Models.TimeZoneListForDropDownResponse>(`${this._baseUrl}/api/shared/v1/TimeZone/ListForDropDown`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TransportHub_Read(idTransportHub?: number, skipErrorHandling: boolean = false): Observable<Models.TransportHub> {
    let idTransportHubParam: string = idTransportHub != null && idTransportHub != undefined ? encodeURIComponent('' + idTransportHub) : '';
      return this._http.get<Models.TransportHub>(`${this._baseUrl}/api/shared/v1/TransportHub/Read?idTransportHub=${idTransportHubParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TransportHub_List(filter?: string, skipErrorHandling: boolean = false): Observable<Models.TransportHubListQueryResponse> {
    let filterParam: string = filter != null && filter != undefined ? encodeURIComponent('' + filter) : '';
      return this._http.get<Models.TransportHubListQueryResponse>(`${this._baseUrl}/api/shared/v1/TransportHub/List?filter=${filterParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TransportHub_Create(request: Models.TransportHubCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/shared/v1/TransportHub/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TransportHub_Update(request: Models.TransportHubUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/shared/v1/TransportHub/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TransportHub_Delete(idTransportHub: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idTransportHubParam: string = encodeURIComponent('' + idTransportHub);
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/shared/v1/TransportHub/Delete?idTransportHub=${idTransportHubParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TransportHub_ListForDropDown(skipErrorHandling: boolean = false): Observable<Models.TransportHubListForDropDownQueryResponse> {
    return this._http.get<Models.TransportHubListForDropDownQueryResponse>(`${this._baseUrl}/api/shared/v1/TransportHub/ListForDropDown`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TransportHub_HotelWithIropContact(idTransportHub?: number, idHotelIropContactTypeEnum?: Models.HotelIropContactTypeEnum, skipErrorHandling: boolean = false): Observable<Models.TransportHubAlertOrReminderMassiveActivationQueryResponse> {
    let idTransportHubParam: string = idTransportHub != null && idTransportHub != undefined ? encodeURIComponent('' + idTransportHub) : '';
      let idHotelIropContactTypeEnumParam: string = idHotelIropContactTypeEnum != null && idHotelIropContactTypeEnum != undefined ? encodeURIComponent('' + idHotelIropContactTypeEnum) : '';
      return this._http.get<Models.TransportHubAlertOrReminderMassiveActivationQueryResponse>(`${this._baseUrl}/api/shared/v1/TransportHub/HotelWithIropContact?idTransportHub=${idTransportHubParam}&idHotelIropContactTypeEnum=${idHotelIropContactTypeEnumParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public TransportHub_AlertOrReminderMassiveActivation(request: Models.TransportHubAlertOrReminderMassiveActivationCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/shared/v1/TransportHub/AlertOrReminderMassiveActivation`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_Read(idUser?: number, skipErrorHandling: boolean = false): Observable<Models.User> {
    let idUserParam: string = idUser != null && idUser != undefined ? encodeURIComponent('' + idUser) : '';
      return this._http.get<Models.User>(`${this._baseUrl}/api/identity/v1/User/Read?idUser=${idUserParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_ListUsersInFoodServiceCompany(idSupplierFoodService?: number, skipErrorHandling: boolean = false): Observable<Models.SupplierFoodServiceListUsersQueryResponse> {
    let idSupplierFoodServiceParam: string = idSupplierFoodService != null && idSupplierFoodService != undefined ? encodeURIComponent('' + idSupplierFoodService) : '';
      return this._http.get<Models.SupplierFoodServiceListUsersQueryResponse>(`${this._baseUrl}/api/identity/v1/User/ListUsersInFoodServiceCompany?idSupplierFoodService=${idSupplierFoodServiceParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_ListByEntity(entityInstanceId: number, idEntity: Models.EntityEnum, skipErrorHandling: boolean = false): Observable<Models.UserListByEntityQueryResponse> {
    let entityInstanceIdParam: string = encodeURIComponent('' + entityInstanceId);
      let idEntityParam: string = encodeURIComponent('' + idEntity);
      return this._http.get<Models.UserListByEntityQueryResponse>(`${this._baseUrl}/api/identity/v1/User/ListByEntity?entityInstanceId=${entityInstanceIdParam}&idEntity=${idEntityParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_ReadUserInfo(skipErrorHandling: boolean = false): Observable<Models.UserReadInfoQueryResponse> {
    return this._http.get<Models.UserReadInfoQueryResponse>(`${this._baseUrl}/api/identity/v1/User/ReadUserInfo`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_List(request: Models.UserListQuery, skipErrorHandling: boolean = false): Observable<Models.UserListQueryResponse> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.UserListQueryResponse>(`${this._baseUrl}/api/identity/v1/User/List`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_Create(request: Models.UserCreateCommand, skipErrorHandling: boolean = false): Observable<number> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<number>(`${this._baseUrl}/api/identity/v1/User/Create`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_Delete(idUser?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idUserParam: string = idUser != null && idUser != undefined ? encodeURIComponent('' + idUser) : '';
      return this._http.post<Models.Result>(`${this._baseUrl}/api/identity/v1/User/Delete?idUser=${idUserParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_Update(request: Models.UserUpdateCommand, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let wrappedRequest = this._handleRequest(request);
    return this._http.post<Models.Result>(`${this._baseUrl}/api/identity/v1/User/Update`, wrappedRequest, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_UpdateLanguageCulture(idLanguageCulture?: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idLanguageCultureParam: string = idLanguageCulture != null && idLanguageCulture != undefined ? encodeURIComponent('' + idLanguageCulture) : '';
      return this._http.post<Models.Result>(`${this._baseUrl}/api/identity/v1/User/UpdateLanguageCulture?idLanguageCulture=${idLanguageCultureParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public User_DeleteUserInFoodServiceCompany(idUser: number, idSupplierFoodServiceCompany: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idUserParam: string = encodeURIComponent('' + idUser);
      let idSupplierFoodServiceCompanyParam: string = encodeURIComponent('' + idSupplierFoodServiceCompany);
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/identity/v1/User/DeleteUserInFoodServiceCompany?idUser=${idUserParam}&idSupplierFoodServiceCompany=${idSupplierFoodServiceCompanyParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public UserInEntity_Create(idEntity: Models.EntityEnum, entityInstanceId: number, idUser: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idEntityParam: string = encodeURIComponent('' + idEntity);
      let entityInstanceIdParam: string = encodeURIComponent('' + entityInstanceId);
      let idUserParam: string = encodeURIComponent('' + idUser);
      return this._http.post<Models.Result>(`${this._baseUrl}/api/identity/v1/UserInEntity/Create?idEntity=${idEntityParam}&entityInstanceId=${entityInstanceIdParam}&idUser=${idUserParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public UserInEntity_CreateByUsername(idEntity: Models.EntityEnum, entityInstanceId: number, email: string, skipErrorHandling: boolean = false): Observable<string> {
    let idEntityParam: string = encodeURIComponent('' + idEntity);
      let entityInstanceIdParam: string = encodeURIComponent('' + entityInstanceId);
      let emailParam: string = encodeURIComponent('' + email);
      return this._http.post<string>(`${this._baseUrl}/api/identity/v1/UserInEntity/CreateByUsername?idEntity=${idEntityParam}&entityInstanceId=${entityInstanceIdParam}&email=${emailParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

  public UserInEntity_Delete(idEntity: Models.EntityEnum, entityInstanceId: number, idUser: number, skipErrorHandling: boolean = false): Observable<Models.Result> {
    let idEntityParam: string = encodeURIComponent('' + idEntity);
      let entityInstanceIdParam: string = encodeURIComponent('' + entityInstanceId);
      let idUserParam: string = encodeURIComponent('' + idUser);
      return this._http.delete<Models.Result>(`${this._baseUrl}/api/identity/v1/UserInEntity/Delete?idEntity=${idEntityParam}&entityInstanceId=${entityInstanceIdParam}&idUser=${idUserParam}`, httpOptions)
      .pipe(
        map(x => this._handleResponse(x)),
        catchError((err, obs) => this._handleError(err, obs, skipErrorHandling))
      );
  }

}